import React from "react"
import { Dialog, 
        DialogTitle, 
        DialogContent, 
        DialogActions, 
        Button, 
        Typography } from "@mui/material"

export default function ZukanSavedDialog({
    open,
    onClose,
    message = "図鑑に登録しました。",
    }) {
    return (
        <Dialog open={open} onClose={onClose}>
        <DialogTitle sx={{ fontFamily: "DotGothic16", fontSize: "18px" }}>
            おしらせ
        </DialogTitle>

        <DialogContent>
            <Typography sx={{ fontFamily: "DotGothic16", fontSize: "16px" }}>
            {message}
            </Typography>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose} sx={{ fontFamily: "DotGothic16" }}>
            OK
            </Button>
        </DialogActions>
        </Dialog>
    )
}
